module.exports = __webpack_public_path__ + "static/contactImg-41694268eff1497922497f8b167a9787.jpg";